import { use } from "i18next";
import { initReactI18next } from "react-i18next";

import package_ from "../package.json" with { type: "json" };
import TRANSLATIONS_EN from "./languages/en.json";

// English-only for now (mirrors proof-portal-ui/consumer-portal). uikit i18n
// bundles are intentionally omitted — workbench renders its own components and
// pulls in no uikit React components yet (only uikit-tokens CSS).
const resources = {
  en: {
    translation: {
      ...TRANSLATIONS_EN,
    },
  },
};

const i18n = use(initReactI18next); // passes i18n down to react-i18next

// init() resolves synchronously here (inline resources, no backend), so the
// instance is usable immediately. Floating promise is intentional.
void i18n.init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
    defaultVariables: { packageName: package_.name },
  },
});

export default i18n;
